import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SmallBusiness = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M124.5 44C124.5 41.7909 122.709 40 120.5 40H24.5C22.2909 40 20.5 41.7909 20.5 44V120C20.5 122.209 22.2909 124 24.5 124H120.5C122.709 124 124.5 122.209 124.5 120V44Z",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("path", {
      d: "M105.5 79.8555C105.5 77.6463 103.709 75.8555 101.5 75.8555H81.5C79.2909 75.8555 77.5 77.6463 77.5 79.8555V123.855H105.5V79.8555Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      d: "M65.0645 80.0137C65.0645 77.8045 63.2736 76.0137 61.0645 76.0137H41.0645C38.8553 76.0137 37.0645 77.8045 37.0645 80.0137V100.014C37.0645 102.223 38.8553 104.014 41.0645 104.014H61.0645C63.2736 104.014 65.0645 102.223 65.0645 100.014V80.0137Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.5 44H120.5V120H105.5V79.8555C105.5 77.6463 103.709 75.8555 101.5 75.8555H81.5C79.2909 75.8555 77.5 77.6463 77.5 79.8555V120H24.5V44ZM120.5 40C122.709 40 124.5 41.7909 124.5 44V120C124.5 122.209 122.709 124 120.5 124H24.5C22.2909 124 20.5 122.209 20.5 120V44C20.5 41.7909 22.2909 40 24.5 40H120.5ZM81.5 79.8555H101.5V119.855H81.5V79.8555ZM61.0645 80.0137H41.0645V100.014H61.0645V80.0137ZM65.0645 80.0137C65.0645 77.8045 63.2736 76.0137 61.0645 76.0137H41.0645C38.8553 76.0137 37.0645 77.8045 37.0645 80.0137V100.014C37.0645 102.223 38.8553 104.014 41.0645 104.014H61.0645C63.2736 104.014 65.0645 102.223 65.0645 100.014V80.0137Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M101.5 20H70.5V51.5C70.5 60.0604 77.4396 67 86 67C94.5604 67 101.5 60.0604 101.5 51.5V20Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M73.5 20H42.5V51.5C42.5 60.0604 49.4396 67 58 67C66.5604 67 73.5 60.0604 73.5 51.5V20Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M45.5 20H16.5C15.3954 20 14.5 20.8954 14.5 22V51.5C14.5 60.0604 21.4396 67 30 67C38.5604 67 45.5 60.0604 45.5 51.5V20Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M129.5 22C129.5 20.8954 128.605 20 127.5 20H98.5V51.5C98.5 60.0604 105.44 67 114 67C122.56 67 129.5 60.0604 129.5 51.5V22Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M125.5 51.5V24H102.5V51.5C102.5 57.8513 107.649 63 114 63C120.351 63 125.5 57.8513 125.5 51.5ZM129.5 22C129.5 20.8954 128.605 20 127.5 20H101.5H98.5H73.5H70.5H45.5H42.5H16.5C15.3954 20 14.5 20.8954 14.5 22V51.5C14.5 60.0604 21.4396 67 30 67C36.1762 67 41.5087 63.3876 44 58.1605C46.4913 63.3876 51.8238 67 58 67C64.1762 67 69.5087 63.3876 72 58.1605C74.4913 63.3876 79.8238 67 86 67C92.1762 67 97.5087 63.3876 100 58.1605C102.491 63.3876 107.824 67 114 67C122.56 67 129.5 60.0604 129.5 51.5V22ZM97.5 24H74.5V51.5C74.5 57.8513 79.6487 63 86 63C92.3513 63 97.5 57.8513 97.5 51.5V24ZM69.5 24H46.5V51.5C46.5 57.8513 51.6487 63 58 63C64.3513 63 69.5 57.8513 69.5 51.5V24ZM18.5 24H41.5V51.5C41.5 57.8513 36.3513 63 30 63C23.6487 63 18.5 57.8513 18.5 51.5V24Z",
      fill: colors.illustration.stroke
    })]
  });
};
//# sourceMappingURL=SmallBusiness.js.map